import type { HealthLevel } from './types';

export function formatDurationMs(ms: number): string {
  return formatDuration(Math.max(0, Math.round(ms / 1000)));
}

export function sessionEndReasonLabel(
  reason: 'logout' | 'idle' | 'disconnect' | 'revoked' | 'expired' | null,
): string {
  switch (reason) {
    case 'logout':
      return 'Logout';
    case 'idle':
      return 'Idle timeout';
    case 'disconnect':
      return 'Disconnected';
    case 'revoked':
      return 'Revoked';
    case 'expired':
      return 'Expired';
    default:
      return '—';
  }
}

export function formatDuration(seconds: number): string {
  if (seconds < 60) return `${seconds}s`;
  const mins = Math.floor(seconds / 60);
  const hrs = Math.floor(mins / 60);
  const days = Math.floor(hrs / 24);
  if (days > 0) return `${days}d ${hrs % 24}h`;
  if (hrs > 0) return `${hrs}h ${mins % 60}m`;
  return `${mins}m`;
}

export function usageLevel(percent: number): HealthLevel {
  if (percent >= 90) return 'error';
  if (percent >= 80) return 'warning';
  return 'ok';
}

export function healthLabel(level: HealthLevel): string {
  switch (level) {
    case 'ok':
      return 'Healthy';
    case 'warning':
      return 'Attention';
    case 'error':
      return 'Critical';
    case 'paused':
      return 'Paused';
    case 'info':
      return 'In progress';
    default:
      return level;
  }
}

export function ringStrokeClass(level: HealthLevel): string {
  switch (level) {
    case 'ok':
      return 'text-emerald-500';
    case 'warning':
      return 'text-amber-500';
    case 'error':
      return 'text-rose-500';
    case 'paused':
      return 'text-slate-400';
    case 'info':
      return 'text-sky-500';
    default:
      return 'text-slate-400';
  }
}

/** User-facing read-only sync status page. */
export function systemHealthStatusPath(): string {
  return '/system-health';
}

/** Full admin diagnostics (server, disk, security, live logs). */
export function systemHealthAdminPath(): string {
  return '/admin/system-health';
}

/** Dashboard widgets: admins get full page; view-only users get status page. */
export function systemHealthLinkPath(canEdit: boolean): string {
  return canEdit ? systemHealthAdminPath() : systemHealthStatusPath();
}
